import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { DetalleConvocatoriaPostulacionesDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class DetalleConvocatoriaPostulacionesService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getDetalleConvocatoriaPostulacionesService(): Observable<BodyListResponse<DetalleConvocatoriaPostulacionesDTO>> {
    return this.http.get<BodyListResponse<DetalleConvocatoriaPostulacionesDTO>>(API_URL + '/api/v1/detalleConvocatoriaPostulaciones/todos');
  }

  guardarDetalleConvocatoriaPostulacionesService(detalleConvocatoriaPostulacionesDTO: DetalleConvocatoriaPostulacionesDTO): Observable<BodyResponse<DetalleConvocatoriaPostulacionesDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/detalleConvocatoriaPostulaciones', detalleConvocatoriaPostulacionesDTO);
  }

  getDetalleConvocatoriaPostulacionesPorCodigoService(codigo: string): Observable<BodyResponse<DetalleConvocatoriaPostulacionesDTO>> {
    return this.http.get<BodyResponse<DetalleConvocatoriaPostulacionesDTO>>(API_URL + '/api/v1/detalleConvocatoriaPostulaciones/' + codigo);
  }
  ////
  obtenerValidacionPostulacionEstudiante(detalleConvocatoriaPostulacionesDTO: DetalleConvocatoriaPostulacionesDTO): Observable<BodyListResponse<DetalleConvocatoriaPostulacionesDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/detalleConvocatoriaPostulaciones/validacionPostulacionEstudiante', detalleConvocatoriaPostulacionesDTO);
  }

  obtenerMisPostulacionesEstudiante(codigoEstudiante: string, codigoConvocatoria: string): Observable<BodyListResponse<DetalleConvocatoriaPostulacionesDTO>> {
    return this.http.get<BodyListResponse<DetalleConvocatoriaPostulacionesDTO>>(API_URL + '/api/v1/detalleConvocatoriaPostulaciones/misPostulacionesEstudiante/estudiante/' + codigoEstudiante + '/' + codigoConvocatoria);
  }

  getValidacionNumeroPostulaciones(codigoConvocatoriaPostulacion: string): Observable<BodyResponse<any>> {
    return this.http.get<BodyResponse<any>>(API_URL + '/api/v1/detalleConvocatoriaPostulaciones/validacionNumeroPostulaciones/' + codigoConvocatoriaPostulacion);
  }


  obtenerPostulantesPorConvocatoriaEscuelaEstadoPostulacion(codigoConvocatoria: string, codigoEscuela: string, estadoPostulacion: string): Observable<BodyListResponse<any>> {
    return this.http.get<BodyListResponse<any>>(API_URL + '/api/v1/detalleConvocatoriaPostulaciones/convocatoria/escuela/' + codigoConvocatoria + '/' + codigoEscuela + '/' + estadoPostulacion);
  }

  getPostulantesPorConvocatoriaPorEstadoPostulacion(codigo: string, estadoPostulacion: string): Observable<BodyListResponse<DetalleConvocatoriaPostulacionesDTO>> {
    return this.http.get<BodyListResponse<DetalleConvocatoriaPostulacionesDTO>>(API_URL + '/api/v1/detalleConvocatoriaPostulaciones/convocatoria/' + codigo + '/' + estadoPostulacion);
  }
  // notificar firma de convenio

  notificarDetalleConvocatoriaPostulacionesService(listado: any): Observable<BodyListResponse<DetalleConvocatoriaPostulacionesDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/detalleConvocatoriaPostulaciones/notificacionMasivaFirmaConvenios', listado);
  }
  // eliminar la postulacion

  eliminarcionPostulacionEstudiante(codigo: string): Observable<BodyListResponse<DetalleConvocatoriaPostulacionesDTO>> {
    return this.http.delete<any>(API_URL + '/api/v1/detalleConvocatoriaPostulaciones/eliminar/postulaciones/' + codigo);
  }
}
